import UploadImage from './UploadImage'


export { UploadImage }